import React from 'react';

import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';
import { Card } from '@buildoutinc/blueprint-react/ui/Card';

import SparkBadge from './spark_badge';

interface Props {
  isAdmin: boolean;
  onClose: () => void;
  onToggleAdminDetails: () => void;
}

export default function AssistantHeader({ isAdmin, onClose, onToggleAdminDetails }: Props) {
  return (
    <Card.Header className="d-flex align-items-center gap-2">
      <SparkBadge onClick={isAdmin ? onToggleAdminDetails : undefined} />
      <Card.Title className="flex-grow-1 mb-0">Otto</Card.Title>
      <Button
        aria-label="Collapse"
        icon={faChevronRight}
        size="sm"
        variant="ghost"
        onClick={onClose}
      />
    </Card.Header>
  );
}
